import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

interface GlobalScrollStylesProps {
  baseColor?: string;
  sizePx?: number;
}

function hexToRgba(hex: string, alpha: number): string {
  const normalized = hex.replace('#', '');
  const bigint = parseInt(
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized,
    16,
  );
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const GlobalScrollStyles: React.FC<GlobalScrollStylesProps> = ({
  baseColor = '#6D46DD',
  sizePx = 6,
}) => {
  return (
    <GlobalStyles
      styles={{
        // Firefox
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${hexToRgba(baseColor, 0.6)} transparent`,
        },
        // WebKit (Chrome, Safari, new Edge)
        '*::-webkit-scrollbar': {
          width: `${sizePx}px`,
          height: `${sizePx}px`,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
          borderRadius: '3px',
        },
        '*::-webkit-scrollbar-thumb': {
          background: hexToRgba(baseColor, 0.6),
          borderRadius: '3px',
          border: `1px solid ${hexToRgba(baseColor, 0.3)}`,
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: hexToRgba(baseColor, 0.75),
        },
        '*::-webkit-scrollbar-corner': {
          background: 'transparent',
        },
        // IE/Edge legacy (best effort)
        '*::-ms-scrollbar': {
          width: `${sizePx}px`,
          height: `${sizePx}px`,
        },
        '*::-ms-scrollbar-track': {
          background: 'transparent',
        },
        '*::-ms-scrollbar-thumb': {
          background: hexToRgba(baseColor, 0.6),
          borderRadius: '3px',
        },
      }}
    />
  );
};

export default GlobalScrollStyles;
